import { Action } from '@ngrx/store';

export enum ConversationsActionType {
    LOAD_CONVERSATIONS = '[Messenger/ConversationsList] LOAD_CONVERSATIONS',
    LOAD_CONVERSATIONS_FAILED = '[Messenger/ConversationsList] LOAD_CONVERSATIONS_FAILED',
    LOAD_CONVERSATIONS_SUCCEEDED = '[Messenger/ConversationsList] LOAD_CONVERSATIONS_SUCCEEDED',
    CREATE_NEW_CONVERSATION = '[Messenger/ConversationsList] CREATE_NEW_CONVERSATION',
    CREATE_NEW_CONVERSATION_FAILED = '[Messenger/ConversationsList] CREATE_NEW_CONVERSATION_FAILED',
    CREATE_NEW_CONVERSATION_SUCCEEDED = '[Messenger/ConversationsList] CREATE_NEW_CONVERSATION_SUCCEEDED',
}


export class LoadConversationsAction implements Action {
    readonly type = ConversationsActionType.LOAD_CONVERSATIONS;
    constructor() {}
}

export class LoadConversationsFailedAction implements Action {
    readonly type = ConversationsActionType.LOAD_CONVERSATIONS_FAILED;
    constructor(public error: any) {}
}

export class LoadConversationsSucceededAction implements Action {
    readonly type = ConversationsActionType.LOAD_CONVERSATIONS_SUCCEEDED;
    constructor(public conversations: any) {}
}

export class CreateNewConversationAction implements Action {
    readonly type = ConversationsActionType.CREATE_NEW_CONVERSATION;
    constructor(public userID: string) {}
}

export class CreateNewConversationFailedAction implements Action {
    readonly type = ConversationsActionType.CREATE_NEW_CONVERSATION_FAILED;
    constructor(public error: any) {}
}

export class CreateNewConversationSucceededAction implements Action {
    readonly type = ConversationsActionType.CREATE_NEW_CONVERSATION_SUCCEEDED;
    constructor() {}
}

export type ConversationsAction
    = LoadConversationsAction
    | LoadConversationsFailedAction
    | LoadConversationsSucceededAction
    | CreateNewConversationAction
    | CreateNewConversationFailedAction
    | CreateNewConversationSucceededAction;
